export const ZENDESK_REQUEST_BASE_URL = 'https://shalion.zendesk.com/hc'

/** Opens Zendesk through a branded redirect page (`src/app/api/support/route.ts`). */
export const ZENDESK_SUPPORT_ROUTE = '/api/support'
